import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { useSelector } from "react-redux";

import { SubTab } from "../Cms/TabNInput";
import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { API } from "../../constant/api";
import moment from "moment";

const Activated = () => (
  <span className="label label-lg label-light-success label-inline">
    Activated
  </span>
);

const Deactivated = () => (
  <span className="label label-lg label-light-danger label-inline">
    Deactivated
  </span>
);

const ViewOne = (props) => {
  const { id } = props.match.params;

  const [userData, setUserData] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  const { response: responseUserData, request: requestUserData } = useRequest();

  const { date_format } = useSelector((state) => state.setting);

  useEffect(() => {
    requestUserData("GET", `vendor/${id}`);

    document.title = "View Store - Easyspare";
  }, []);

  useEffect(() => {
    if (responseUserData) {
      const {
        firstName,
        lastName,
        email,
        contact,
        profilePic,
        countryCode,
        // dob,
        positionName,
        role,
        isActive,
        createdAt,
      } = responseUserData.vendor;
      const {
        attachments,
        businessAddress,
        businessName,
        brandName,
        carBrand,
        personalAddress,
      } = responseUserData.vendorDetails;
      setUserData([
        { title: "First Name", value: firstName },
        { title: "Last Name", value: lastName },
        { title: "Email", value: email ? email : "-" },
        {
          title: "Contact",
          value: contact ? `+${countryCode} ` + contact : "-",
        },
        // { title: "Country Code", value: countryCode },
        // { title: "DOB", value: dob ? moment(dob).format("YYYY-MM-DD") : "-" },
        { title: "Position", value: positionName },
        { title: "Role", value: role },
        { title: "City", value: personalAddress.city ? personalAddress.city: "-"},
        { title: "State", value: personalAddress.state ? personalAddress.state: "-"},
        { title: "Country", value: personalAddress.country ? personalAddress.country: "-"},
        { title: "Postal Code", value: personalAddress.postal_code ? personalAddress.postal_code: "-"},
        { title: "Personal Address", value: personalAddress.address ? personalAddress.address: "-"},
        {
          title: "Status",
          value: isActive ? <Activated /> : <Deactivated />,
        },
        {
          title: "Registered On",
          value: <Moment format={date_format}>{createdAt}</Moment>,
        },
        {
          title: "Profile Picture",
          value:
            profilePic?.length > 0 ? (
              <div className="d-flex" style={{ gap: "20px" }}>
                <img
                  data-fancybox
                  src={`${API.PORT}/${profilePic}`}
                  width="100px"
                  alt=""
                />
              </div>
            ) : (
              <p>No pictures found !</p>
            ),
        },
      ]);
      const newData = (Array.isArray(carBrand) ? carBrand : [])
        .filter((item) => item != null && item.name != null)
        .map((item) => `${item.name},`);
      setUserDetails([
        {
          title: "Attachment",
          value:
            attachments.length > 0 ? (
              <img
                // src={`${API.PORT}/${attachments.map((val)=> val.legalDocument ? val.legalDocument : val.businessProfile )}`}
                src={
                  attachments.length > 0 ? `${API.PORT}/${attachments[0]}` : ""
                }
                width={150}
                height={100}
                alt=""
                style={{ cursor: "pointer", marginBottom: "10px" }}
                data-fancybox
              />
            ) : (
              "-"
            ),
        },
        { title: "Business Name", value: businessName },
        { title: "City", value: businessAddress.city?.name ? businessAddress.city?.name :"-"},
        { title: "State", value: businessAddress.state ? businessAddress.state :"-"},
        { title: "Country", value: businessAddress.country ? businessAddress.country :"-"},
        { title: "Postal Code", value: businessAddress.postal_code ? businessAddress.postal_code :"-"},
        { title: "Business Address", value: businessAddress.address ? businessAddress.address :"-"},
        { title: "Brand", value: newData },
      ]);
    }
  }, [responseUserData]);

  const currentTabIndexHandler = (idx) => {
    setTabIndex(idx);
  };

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="View Store"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/stores", name: "Back To Stores" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom gutter-b">
            <div className="card-header card-header-tabs-line">
              <div className="card-toolbar">
                <ul
                  className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                  role="tablist"
                >
                  {["Personal Information", "Business Information"].map(
                    (data, index) => (
                      <SubTab
                        key={index}
                        name={data}
                        index={index}
                        onClick={currentTabIndexHandler}
                      />
                    )
                  )}
                </ul>
              </div>
            </div>
            <div
              style={{
                display: tabIndex === 0 ? "block" : "none",
              }}
              className="card-body px-0"
            >
              <div className="tab-content px-10">
                <div
                  className={`tab-pane ${tabIndex === 0 ? "active" : ""}`}
                  id={`kt_apps_contacts_view_tab_0`}
                  role="tabpanel"
                >
                  {userData.length > 0 &&
                    userData.map((user, index) => (
                      <div key={index} className="form-group row my-2">
                        <label className="col-4 col-form-label">
                          {user.title}
                        </label>
                        <div className="col-8">
                          <span className="form-control-plaintext font-weight-bolder">
                            {user.value}
                          </span>
                        </div>
                      </div>
                    ))}

                  <div className="row"></div>
                </div>
              </div>
            </div>

            <div
              style={{
                display: tabIndex === 1 ? "block" : "none",
              }}
              className="card-body px-0"
            >
              <div className="tab-content px-10">
                <div
                  className={`tab-pane ${tabIndex === 1 ? "active" : ""}`}
                  id={`kt_apps_contacts_view_tab_1`}
                  role="tabpanel"
                >
                  {userDetails.length > 0 &&
                    userDetails.map((user, index) => (
                      <div key={index} className="form-group row my-2">
                        <label className="col-4 col-form-label">
                          {user.title}
                        </label>
                        <div className="col-8">
                          <span className="form-control-plaintext font-weight-bolder">
                            {user.value}
                          </span>
                        </div>
                      </div>
                    ))}

                  <div className="row"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOne;
